import { code } from "@spscommerce/utils";

export const SpsContentRowExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                template: code`
                    <sps-content-row *ngFor="let thing of things">
                      <sps-content-row-col>
                        <i [spsIcon]="thing.icon" [attr.aria-label]="thing.statusLabel" spsIconSize="lg" class="align-middle mr-2 pr-1"></i>
                        <div class="d-inline-block align-middle">
                          <div class="fs-14 lh-20"><a href="#">{{thing.title}}</a></div>
                          <div>{{thing.subtitle}}</div>
                        </div>
                      </sps-content-row-col>
                      <sps-content-row-col width="9.25rem">
                        {{thing.stuff}}
                      </sps-content-row-col>
                      <sps-content-row-col width="3.625rem" leaner>
                        <sps-dropdown aria-label="Actions" [options]="[]"></sps-dropdown>
                      </sps-content-row-col>
                    </sps-content-row>
                `,
                class: code`
                    class DemoComponent {
                        things = [
                            {
                                icon: SpsIcon.STATUS_ERROR,
                                statusLabel: "Error",
                                title: "Title",
                                subtitle: "Subtitle",
                                stuff: "Pretend there's some stuff here.",
                            },
                            {
                                icon: SpsIcon.STATUS_OK,
                                statusLabel: "Success",
                                title: "Title",
                                subtitle: "Subtitle",
                                stuff: "Pretend there's some stuff here.",
                            },
                            {
                                icon: SpsIcon.STATUS_IN_TRANSIT,
                                statusLabel: "Processing",
                                title: "Title",
                                subtitle: "Subtitle",
                                stuff: "Pretend there's some stuff here.",
                            },
                        ];
                    }
                `
            },
            borderlessCol: {
                description: code`<p>The horizontal border of a content row column can be removed.</p>`,
                template: code`
                    <sps-content-row>
                        <sps-content-row-col>
                            <div class="fs-14 lh-20">Heading/Title</div>
                        </sps-content-row-col>
                        <sps-content-row-col width="9.25rem" borderless>
                            General Text Content
                        </sps-content-row-col>
                    </sps-content-row>
                `
            }
        }
    },
    expandable: {
        label: "Expandable",
        examples: {
            expandable: {
                template: code`
                    <sps-content-row (expanded)="onExpand()" (collapsed)="onCollapse()" id="expanded">
                        <sps-content-row-col>
                            <div class="fs-14 lh-20">Heading</div>
                        </sps-content-row-col>
                        <sps-content-row-col width="9.25rem">
                            General Text Content
                        </sps-content-row-col>
                        <sps-content-row-expansion>
                            <sps-card>
                                <br/><br/><br/><br/>
                                Additional content
                                <br/><br/><br/><br/>
                            </sps-card>
                        </sps-content-row-expansion>
                    </sps-content-row>
                `,
                class: code`
                    class DemoComponent {
                        onExpand() {
                            console.log("Content row expanded");
                        }

                        onCollapse() {
                            console.log("Content row collapsed");
                        }
                    }
                `
            }
        }
    },
    card: {
        label: "In a Card",
        examples: {
            card: {
                template: code`
                    <sps-card>
                        <sps-card-header title="Card Cap" icon="chart-pie"></sps-card-header>
                        <sps-content-row *ngFor="let thing of things">
                            <sps-content-row-col>
                                <div class="fs-14 lh-20">{{thing.title}}</div>
                            </sps-content-row-col>
                            <sps-content-row-col width="9.25rem">
                                {{thing.stuff}}
                            </sps-content-row-col>
                            <sps-content-row-expansion>
                                <sps-card>
                                    <br/><br/>
                                    Additional content
                                    <br/><br/>
                                </sps-card>
                            </sps-content-row-expansion>
                        </sps-content-row>
                    </sps-card>
                `,
                class: code`
                    class DemoComponent {
                        things = [
                            {
                                title: "Title",
                                stuff: "Pretend there's some stuff here.",
                            },
                            {
                                title: "Title",
                                stuff: "Pretend there's some stuff here.",
                            },
                            {
                                title: "Title",
                                stuff: "Pretend there's some stuff here.",
                            },
                        ];
                    }
                `
            }
        }
    }
};
